import React, { useState } from 'react'
import moment from 'moment';
import store from '../../../store';
import { connect } from "react-redux";
import AccountLoader from '../../manageAccount/accountLoader';
import Calendar from '../common/calendar';
import Input from '../common/input/Input';
import Button from '../common/input/Button';
import { ExIcon } from '../common/svg';
import Alert from '../common/Alert';
import { apiUrl } from '../common/constants';
import { GetRequest } from '../common/helper';
import TripDetails from './tripDetails';
import { updatePnrEnqiryTripData } from '../../../actions/search-actions';
import {t, ENTER_PNR_NUMBRE,PNR_TICKET_NO } from '../../../translations/pnrEnquiry/Trip/Trip';
import {tCommon, SEARCH } from '../../../translations/Common';

const PnrService = (props) => {
    const [user, setUser] = useState({ pnr: '' });
    const [loader, setLoader] = useState(false);
    const [alert, setAlert] = useState({ show: false, msg: '' });
    const [data, setData] = useState({ topDtls: {}, pickdropDtls: {} });
    const [selDate, setSelDate] = useState(new Date());
    const propdata = store.getState();
    const tripData = propdata.search.pnrEnquiryTripData;
    const handleChange = (val, param) => {
        user[param] = val;
        setUser({ ...user });
    }

    const handleAlert = (msg = false) => {
        if (msg) {
            setAlert({ show: true, msg });
        } else {
            setAlert({ show: false, msg: '' })
        }
    }

    const verify = () => {
        const pnr = user.pnr;
        if (pnr) {
            setLoader(true);
            const url = `${apiUrl.tripStatusDetails}?PNR=${pnr}&TripCode=&date=null`;
            GetRequest(url).then(result => {
                setLoader(false);
                if (result.IsSuccess) {
                    // let res = JSON.parse(result.Data);
                    let res = result.Data;
                    let details = {}
                    if ((res && res.length > 0)) {
                        details['topDtls'] = res;
                        details['pickdropDtls'] = res[0].PickupDetails;
                        // setData({ ...details });
                        store.dispatch(updatePnrEnqiryTripData(details));
                    }
                    else {
                        store.dispatch(updatePnrEnqiryTripData({ topDtls: {}, pickdropDtls: {} }));
                    }

                } else {
                    store.dispatch(updatePnrEnqiryTripData({ topDtls: {}, pickdropDtls: {} }));
                }
            })
        } else {
            setAlert({ show: true, msg: 'Please enter the pnr number' })
        }
    }
    return (
        <>
            {loader && <AccountLoader />}
            {Object.keys(tripData.topDtls).length === 0 && Object.keys(tripData.pickdropDtls).length === 0 &&
                <div className='tripStatus-tripCode'>
                    <div className="tripCode_container">
                        <div className='firstInput' style={{ width: '100%' }}>
                            <Input label={t(PNR_TICKET_NO)} type='text' value={user.pnr} onChange={(e) => { handleChange(e, 'pnr') }} validation={'pnr'} errMsg='' autoFocus={true} />
                        </div>
                        <div className="verify-button">
                            <Button text={tCommon(SEARCH)} className={`button ${String(user.pnr).length > 3 ? 'active' : 'disable'}`} extraStyle={{ "height": "48px", "width": "160px" }} onClick={() => (String(user.pnr).length > 3) && verify()} />
                        </div>
                    </div>
                    <div className="tripStatus-tripCodeMessage">
                        <div className="message" style={{ display: 'flex', marginTop: '6px' }}>
                            <span style={{ marginRight: '6px' }}><ExIcon /></span><span>{t(ENTER_PNR_NUMBRE)}</span>
                        </div>
                    </div>
                </div >
            }
            {
                tripData.topDtls &&
                tripData.topDtls.length > 0 &&
                tripData.pickdropDtls && tripData.pickdropDtls.length > 0 &&
                <div className='booking-cards'>
                    <TripDetails topDtls={tripData.topDtls} pickdropDtls={tripData.pickdropDtls} />
                </div>
            }
            {
                alert.show &&
                <Alert msg={alert.msg} error={true} close={() => handleAlert()} />
            }
        </>
    )
}

const mapStateToProps = function (store) {
    return store;
};

export default connect(mapStateToProps)(PnrService);